module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    ref: "wrapElm"
  }, [(_vm.isHtml == true) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.transText)
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.transText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-659a6396!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/TransText.vue
// module id = 709
// module chunks = 0